import { render, staticRenderFns } from "./SpecialistModule.vue?vue&type=template&id=6ce43638"
import script from "./SpecialistModule.vue?vue&type=script&lang=js"
export * from "./SpecialistModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports